import SiteNavbar from '../organisms/SiteNavbar';
import Hero from '../organisms/Hero';
import StatStrip from '../organisms/StatStrip';
import HowItWorks from '../organisms/HowItWorks';
import MenuSection from '../organisms/MenuSection';
import PanelSection from '../organisms/PanelSection';
import WhatsappSection from '../organisms/WhatsappSection';
import OperationSection from '../organisms/OperationSection';
import ObjectionsSection from '../organisms/ObjectionsSection';
import Pricing from '../organisms/Pricing';
import Faq from '../organisms/Faq';
import FinalCta from '../organisms/FinalCta';
import SiteFooter from '../organisms/SiteFooter';
import StickyWhatsapp from '../organisms/StickyWhatsapp';
import ScrollDepthTracker from '../organisms/ScrollDepthTracker';

/**
 * A ordem da página segue a ordem das perguntas de quem chega:
 *
 *   o que é isto (herói) → em quanto tempo funciona (passos) → o que o meu
 *   cliente vê (cardápio) → o que EU vejo (painel) → como o pedido chega
 *   (WhatsApp) → e as minhas regras (entrega e pagamento) → e aquelas dúvidas
 *   que travam antes do preço (objeções) → quanto custa (planos) → e o resto
 *   das perguntas (FAQ) → então tá (chamada final).
 *
 * As seções alternam fundo — branco, cinza, branco, roxo — para a rolagem ter
 * marcos. Sem isso a página vira um rolo de cartões e ninguém sabe onde está.
 */
function LandingPage() {
  return (
    <>
      <a className="skip-link" href="#conteudo">Pular para o conteúdo</a>
      <SiteNavbar />

      <main id="conteudo">
        <Hero />
        <StatStrip />
        <HowItWorks />
        <MenuSection />
        <PanelSection />
        <WhatsappSection />
        <OperationSection />
        <ObjectionsSection />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>

      <SiteFooter />
      <StickyWhatsapp />
      <ScrollDepthTracker />
    </>
  );
}

export default LandingPage;
